import { Phone, X } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useTranslation } from '../../lib/i18n';
import { formatClock } from '../../lib/format';
import { useNow } from '../../lib/useNow';
import type { VoiceCallSnapshot } from './useVoiceCall';

export function CallStatus({ snapshot, onDismiss }: { snapshot: VoiceCallSnapshot; onDismiss(): void }) {
  const { t } = useTranslation();
  const active = snapshot.phase === 'active';
  const now = useNow(1000, active);
  const elapsed = formatClock(Math.max(0, now - (snapshot.startedAt ?? now)));
  if (snapshot.phase === 'idle') return null;
  const label = active
    ? t.voice.call.states[snapshot.state === 'listening' && snapshot.speaking ? 'speaking' : snapshot.state]
    : snapshot.reason ? t.voice.call.reasons[snapshot.reason] : '';
  return <div data-testid="voice-call-status"
    className={active ? 'flex min-w-0 flex-1 items-center gap-2 px-2 py-2 text-ui text-muted-foreground'
      : 'order-last flex w-full items-start gap-2 px-2 text-ui text-muted-foreground'}>
    {active && <>
      <Phone size={16} className="shrink-0" aria-hidden />
      <span className="shrink-0 tabular-nums">{elapsed}</span>
    </>}
    <span role={snapshot.phase === 'error' ? 'alert' : 'status'} aria-atomic="true"
      title={active ? label : undefined}
      className={active ? 'min-w-0 truncate' : `min-w-0 flex-1 break-words py-2 ${snapshot.phase === 'error' ? 'text-destructive' : ''}`}>{label}</span>
    {!active && <Button type="button" variant="ghost" size="icon" icon={X}
      onClick={onDismiss} aria-label={t.voice.call.close} />}
  </div>;
}
